//**************************************************************************************************
//  未２要素認証確認ガード
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { SessionService } from '../services/session-service';
//==================================================================================================
//
//==================================================================================================
export const twofactorGuard: CanActivateFn = (route, state) => {
  const sessionService: SessionService = inject(SessionService);
  const router: Router = inject(Router);

  return sessionService.checkLoginState().pipe(map(session => {
    if (!session.isLogin) {
      return router.createUrlTree(['/login']);
    } else {
      if (!session.is2FA) {
        if (!!session.sysAdmin || !!session.leAdmin || !!session.leUser) {
          return true;
        } else {
          sessionService.logout();
          return false;
        }
      } else {
        sessionService.logout();
        return false;
      }
    }
  }));
};
